import { Body } from './Body'
import { Card } from './Card'
import { Description } from './Description'
import { Footer } from './Footer'
import { Header } from './Header'
import { Root } from './Root'
import { Toolbar } from './Toolbar'

export const HUD = {
  Root,
  Body,
  Card,
  Footer,
  Header,
  Toolbar,
  Description
}
